<template>
  <div>

    <br />
    <h5 class="pageTitle">Réinitialisation du mot de passe</h5>

    <br />

    <reset-password-form @valid="passwordValidated" />

    <br />

    <template v-if="errorsBackend.length > 0">
      <span v-for="error in errorsBackend" class="error" style="padding-left: 10px">
        {{ error }}
      </span>
    </template>
  </div>
</template>

<script>
  import { mapActions } from 'vuex';
  import resetPasswordForm from '../../components/Connexion/Connexion_Reinitialisation_Mot_de_passe';

  export default {
    name: 'ResetPassword',
    components: { resetPasswordForm },
    data() {
      return {
        errorsBackend: []
      };
    },
    methods: {
      ...mapActions('account', [ 'resetPassword' ]),

      passwordValidated(data) {
        this.errorsBackend = [];
        data['token'] = this.$route.query.token;

        this.resetPassword(data)
          .then(success => {
            this.$swal({
              title: 'Mot de passe',
              text: 'Votre mot de passe a été réinitialisé avec succès.',
              confirmButtonText: 'Fermer'
            }).then(result => {
              this.$router.push({ name: 'LoginPage' });
            });
          })
          .catch(error => {
            this.errorsBackend.push(error);
          });
      }
    }
  };
</script>

<style scoped>
.error {
  color: #dc3545;
}
</style>
